import { composeIO } from 'react-compose-io'
import { historicoParceiroIO } from './HistoricoParceiro.IO'
import { HistoricoParceiroView } from './HistoricoParceiro.View'

export const HistoricoParceiro = composeIO(HistoricoParceiroView, historicoParceiroIO)
